import {useEffect,useRef,useState} from 'react'
import {usePriceAlerts} from './PriceAlertProvider.jsx'
import {priceAlertName} from '../../lib/priceAlerts/content.js'
import PriceAlertDialog from './PriceAlertDialog.jsx'
import {PriceAlertPrimitive} from '../../lib/chart/PriceAlertPrimitive.js'

export default function PriceAlertLines({series,chart,container,symbol,visible,settings}) {
 const store=usePriceAlerts(),latest=useRef(store),primitive=useRef(null)
 const [editing,setEditing]=useState(null)
 latest.current=store
 useEffect(()=>setEditing(null),[symbol])
 useEffect(()=>{if(editing&&!store?.alerts.some(a=>a.id===editing.id))setEditing(null)},[editing,store?.alerts])
 useEffect(()=>{
  if(!series||!chart||!container)return
  const overlay=new PriceAlertPrimitive(container,
   alert=>latest.current?.submit({action:'delete',id:alert.id,revision:alert.revision}),
   id=>{const alert=latest.current?.alerts.find(a=>a.id===id);if(alert){latest.current.select(id);setEditing({...alert})}},
   (alert,price)=>latest.current?.submit({action:'save',alert:{...alert,price}}))
  primitive.current=overlay;series.attachPrimitive(overlay)
  return ()=>{try{series.detachPrimitive(overlay)}catch{/* Parent chart may already be disposed. */}finally{overlay.detached();primitive.current=null}}
 },[series,chart,container])
 useEffect(()=>{
  primitive.current?.setAlerts((store?.alerts||[]).filter(a=>a.symbol===symbol&&!(a.recurrence==='once'&&a.state==='triggered')&&Number.isFinite(a.price)&&(visible||a.id===store.selectedId)).map(a=>({...a,name:priceAlertName(a.symbol,a.name)})),settings,store?.status==='live',store?.canCommand ?? store?.status==='live')
 },[series,chart,container,symbol,visible,settings,store?.alerts,store?.selectedId,store?.status,store?.canCommand])
 return editing&&editing.symbol===symbol&&store?.alerts.some(a=>a.id===editing.id)
  ? <PriceAlertDialog key={editing.id} symbol={symbol} alert={editing} onClose={()=>setEditing(null)}/> : null
}
